<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Xử lý công việc</h1>
      <div class="float-right">
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary m-r-10"
          @click="$router.push('/customer-support/task')"
        >
          <b-icon icon="arrow-left" aria-hidden="true" />
          Quay lại
        </button>
        <button
          type="button"
          class="font-medium f12 btn btn-outline-primary m-r-10"
          @click="submitForm"
          :disabled="isLoading || !canEdit"
        >
          <b-icon icon="check-lg" aria-hidden="true" />
          Lưu
        </button>
        <!-- <button
          type="button"
          class="font-medium f12 btn btn-outline-primary m-r-10"
          @click="updateStatusComplete"
          :disabled="isLoading || isChange || taskInfo.status !== EnumTaskStatus.PROCESSING"
        >
          <b-icon icon="check-lg" aria-hidden="true" />
          Hoàn thành
        </button> -->
        <button
          type="button"
          class="font-medium f12 btn btn-outline-primary m-r-10"
          @click="handleComplete"
          :disabled="isLoading || !canEdit"
        >
          <b-icon icon="check-lg" aria-hidden="true" />
          Hoàn thành
        </button>
        <button
          v-if="callioConfig.active === true"
          type="button"
          class="font-medium f12 btn btn-outline-primary m-r-10"
          @click="processTaskWithCallio"
        >
          Gọi điện
        </button>
      </div>
      <hr />
    </div>

    <b-container fluid>
      <b-row class="gx-1">
        <b-col cols="12" class="pr-0" md="4">
          <b-card class="card-section">
            <div class="header-section">Thông tin chung</div>
            <div class="form-item">
              <div class="form-label">Nhóm công việc</div>
              <div class="form-input">
                {{ getCategoryName }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Tên công việc</div>
              <div class="form-input">
                {{ getTaskName }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Đối tượng</div>
              <div class="form-input">
                {{ getSubject }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Tên đối tượng</div>
              <div class="form-input">
                <div v-if="['MA', 'STORE'].includes(taskInfo?.applyFor)">
                  <span class="text-muted">MA:</span>
                  <b-link
                    target="_blank"
                    :to="`/customer-support/account/${taskInfo?.merchantInfo?.customerId}`"
                  >
                    {{ taskInfo?.merchantInfo?.merchantName }}
                  </b-link>
                  <p>SĐT: {{ taskInfo?.merchantInfo?.mobile }}</p>
                  <p>Email: {{ taskInfo?.merchantInfo?.email }}</p>
                </div>
                <div v-if="['STORE'].includes(taskInfo?.applyFor)">
                  <span class="text-muted">Store:</span>
                  <b-link
                    target="_blank"
                    :to="`/customer-support/store/${taskInfo?.storeInfo?.storeId}`"
                  >
                    {{ taskInfo?.storeInfo?.name }}"
                  </b-link>
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Hình thức chăm sóc</div>
              <div class="form-input">
                {{ getMethodCareName }}
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Trạng thái</div>
              <div class="form-input">
                <b-badge :variant="getStatusType">{{ getStatusName }}</b-badge>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Người tạo</div>
              <div class="form-input">
                <span v-show="taskInfo.createdBy !== taskInfo.creatorInfo?.userId">⚠️</span>
                <b-link :to="`/staff/detail/?id=${taskInfo.creatorInfo?.userId}`">
                  {{ taskInfo.creatorInfo?.name || '' }}
                </b-link>
                <span v-show="taskInfo.creatorInfo?.userId === currentUser?.userId">(tôi)</span>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Thời gian tạo</div>
              <div class="form-input">
                <div>
                  {{
                    taskInfo.createdTime
                      ? `${formatDate(taskInfo.createdTime)} (${showDateAgo(taskInfo.createdTime)})`
                      : ''
                  }}
                </div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Người xử lý</div>
              <div class="form-input">
                <span v-show="taskInfo.saleId !== taskInfo.handlerRes?.userId">⚠️</span>
                <b-link :to="`/staff/detail/?id=${taskInfo.handlerRes?.userId}`">
                  {{ taskInfo.handlerRes?.name || '' }}
                </b-link>
                <span v-show="taskInfo.handlerRes?.userId === currentUser?.userId">(tôi)</span>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Thời gian cần xử lý</div>
              <div class="form-input">
                <template v-if="taskInfo.startIntend && taskInfo.endIntend">
                  <div>
                    <span class="text-muted d-inline-block" style="width: 25px">Từ:</span>
                    {{
                      `${formatDate(taskInfo.startIntend)} (${showDateAgo(taskInfo.startIntend)})`
                    }}
                  </div>
                  <div>
                    <span class="text-muted d-inline-block" style="width: 25px">Đến:</span>
                    {{ `${formatDate(taskInfo.endIntend)} (${showDateAgo(taskInfo.endIntend)})` }}
                  </div>
                </template>
                <div v-else class="text-muted opacity-50">Không có dữ liệu</div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Lý do</div>
              <div class="form-input">
                <template v-if="taskInfo.note">
                  {{ taskInfo.note }}
                </template>
                <div v-else class="text-muted opacity-50">Không có dữ liệu</div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Ghi chú</div>
              <div class="form-input">
                <template v-if="taskInfo.description">
                  {{ taskInfo.description }}
                </template>
                <div v-else class="text-muted opacity-50">Không có dữ liệu</div>
              </div>
            </div>
          </b-card>

          <b-card class="card-section mt-3">
            <div class="header-section">Thông tin khác</div>
            <!-- <div class="form-item">
              <div class="form-label">Thời gian yêu cầu thực hiện</div>
              <div class="form-input">
                <InputRange v-model="dateRange" :disabled="!canEdit" />
                <div class="error">{{ error.dateRange }}</div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Lý do thực hiện công việc</div>
              <div class="form-input">
                <b-form-input
                  v-model="note"
                  placeholder="Lý do"
                  :disabled="!canEdit"
                />
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Ghi chú</div>
              <div class="form-input">
                <b-form-input
                  v-model="description"
                  placeholder="Ghi chú"
                  :disabled="!canEdit"
                />
              </div>
            </div> -->
            <div class="form-item">
              <div class="form-label require">
                <div>Thời gian thực hiện công việc</div>
                <small class="text-muted">Bắt buộc nhập khi hoàn thành</small>
              </div>
              <div class="form-input">
                <InputRange v-model="dateProcessing" :disabled="!canEdit" />
                <div class="error">{{ error.dateProcessing }}</div>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Kết quả</div>
              <div class="form-input">
                <Select2
                  v-model="result"
                  :options="resultOptions"
                  placeholder="Chọn kết quả"
                  :disabled="!canEdit"
                  @change="setOnchange"
                />
                <div class="error">{{ error.result }}</div>
              </div>
            </div>
            <!-- <div
              class="form-item"
              v-if="
                Array.isArray(taskInfo?.purposes) &&
                taskInfo?.purposes.includes('CHUYEN_DOI_NGAN_LUONG')
              "
            >
              <div class="form-label">Trạng thái chuyển đổi</div>
              <div class="form-input">
                <Select2
                  v-model="transformStatus"
                  :options="transformStatusOptions"
                  placeholder="Chọn trạng thái chuyển đổi"
                  :disabled="!canEdit"
                  @change="setOnchange"
                />
              </div>
            </div> -->
            <div class="form-item" v-show="result === EnumTaskResultStatus.FAILED">
              <div class="form-label require">Lý do thất bại</div>
              <div class="form-input">
                <ReasonFailure
                  v-model="reasonFailure"
                  :disabled="!canEdit"
                  :items="listReasonFailure"
                  @input="setOnchange"
                />
                <div class="error">{{ error.reasonFailure }}</div>
              </div>
            </div>
          </b-card>
          <b-card class="card-section mt-3">
            <div class="header-section">Thông tin cuộc gọi</div>
            <div class="table-responsive text-center p-0">
              <b-table
                striped
                hover
                :items="historyCall"
                :fields="historyCallFields"
                thead-class="thead-light"
                sticky-header="500px"
                responsive
                show-empty
                empty-text="Không có dữ liệu!"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(toNumber)="data">
                  <strong>{{ data.item.toNumber | encryptPhone }}</strong
                  ><br />{{ data.item.contactName }}
                </template>
                <template #cell(username)="data">
                  <strong>{{ data.item.username }}</strong
                  ><br />{{ data.item.userEmail }}
                </template>
                <template #cell(initCallIoTime)="data">
                  {{ data.item.initCallIoTime | formatDate('DD/MM/YYYY HH:mm:ss') }}
                </template>
                <template #cell(createCallIoTime)="data">
                  {{ data.item.createCallIoTime | formatDate('DD/MM/YYYY HH:mm:ss') }}<br />
                  {{ data.item.endCallIoTime | formatDate('DD/MM/YYYY HH:mm:ss') }}
                </template>
                <template #cell(timing)="data">
                  {{ getTiming(data.item.endCallIoTime, data.item.createCallIoTime) }}
                </template>
                <template #cell(direction)="data">
                  {{ data.item.direction | formatDirection }}
                </template>
                <template #cell(crmResult)="data">
                  <span v-if="data.item.crmResult"
                    >{{ data.item.crmResult | resultCall(resultStatusCalls) }}
                    <br />
                    {{ data.item.crmNote }}
                  </span>
                </template>
                <template #cell(action)="data">
                  <b-dropdown class="text-center" variant="outline-light">
                    <b-dropdown-item @click="detailCall(data.item.id)" class="dropdown-item"
                      ><span>&nbsp;</span>Chi tiết
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="data.item.callId"
                      @click="listenRecord(data.item.callId)"
                      class="dropdown-item"
                      ><span>&nbsp;</span>Nghe ghi âm cuộc gọi
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>
          </b-card>
        </b-col>

        <b-col cols="12" class="pr-0" md="5">
          <!-- <b-card class="card-section" v-if="taskInfo.methodCare !== EnumTaskMethodCare.OFFLINE">
            <div class="header-section mb-2">Công việc cần xử lý</div>
              <div v-show="isLoadingSupportInfos" class="no-data">
                loading...
              </div>
              <template v-show="!isLoadingSupportInfos">
                <SupportInfoProcess :isUpdate="isUpdate" ref="supportInfoProcessRef" />
              </template>
            <div class="form-item" style="align-items: start">
              <div class="form-label">Ghi chú của NV chăm sóc</div>
              <div class="form-input">
                <b-form-textarea
                  v-model="afterSaleNote"
                  placeholder="Ghi chú cảu NV chăm sóc, tối đa 255 ký tự"
                  rows="3"
                  max-rows="6"
                  :state="
                    (afterSaleNote || '').length <= 255 ? undefined : false
                  "
                  maxlength="255"
                />
                <div class="error">{{ error.afterSaleNote }}</div>
              </div>
            </div>
          </b-card> -->
          <b-card
            class="card-section"
            v-if="isUpdate && taskInfo.methodCare !== EnumTaskMethodCare.OFFLINE"
          >
            <!-- <div class="header-section mb-2">Thông tin chăm sóc</div> -->
            <div class="header-section mb-2 d-flex justify-content-between">
              <div>Thông tin chăm sóc</div>
              <div v-if="!hasCallioResult">
                <span class="text-danger">*</span>
                <small class="text-muted">: bắt buộc phải nhập</small>
              </div>
            </div>
            <div v-show="isLoadingSupportInfos" class="no-data">loading...</div>
            <template v-if="!isLoadingSupportInfos">
              <div v-show="supportInfos.length">
                <SupportInfo :disabled="!canEdit" ref="supportInfoRef" @change="setOnchange" />
              </div>
              <div v-show="!isLoadingSupportInfos && !supportInfos.length" class="no-data">
                Không có dữ liệu
              </div>
            </template>
            <div class="form-item" style="align-items: start">
              <div class="form-label">Ghi chú của NV chăm sóc</div>
              <div class="form-input">
                <b-form-textarea
                  v-model="afterSaleNote"
                  placeholder="Ghi chú cảu NV chăm sóc, tối đa 255 ký tự"
                  rows="3"
                  max-rows="6"
                  :state="(afterSaleNote || '').length <= 255 ? undefined : false"
                  maxlength="255"
                  :disabled="!canEdit"
                  @change="setOnchange"
                />
                <div class="error">{{ error.afterSaleNote }}</div>
              </div>
            </div>
          </b-card>
          <b-card class="card-section mt-3">
            <div class="header-section mb-2 d-flex justify-content-between">
              <div>Thu thập thông tin</div>
              <small v-if="!hasCallioResult" class="text-muted">Trả lời ít nhất 1 câu</small>
            </div>
            <CollectInformation
              :disabled="!canEdit"
              ref="collectInformationRef"
              @change="setOnchange"
            />
          </b-card>
        </b-col>
        <b-col cols="12" md="3">
          <div v-if="!hasCallioResult">
            <UploadOneOrMultip
              :disabled="!canEdit"
              :title="'Ảnh giải trình'"
              :maxFile="100"
              titleTag="h2"
              :uploadToApi="false"
              :isDragging="true"
              titleClass="form-inner-heading"
              ref="uploadComponent"
              @change="setOnchange"
            />
          </div>
          <div v-else>
            <UploadOneOrMultip
              :disabled="!canEdit"
              :title="'Ảnh giải trình (tùy chọn)'"
              :maxFile="100"
              titleTag="h2"
              :uploadToApi="false"
              :isDragging="true"
              titleClass="form-inner-heading"
              ref="uploadComponent"
              @change="setOnchange"
            />
          </div>

          <b-card class="card-section mt-3">
            <div class="header-section mb-2 d-flex justify-content-between align-items-center">
              <div>Thông tin trợ giúp, hỗ trợ</div>
              <img :src="HotIcon" alt="" style="width: 21px; height: 9px" />
            </div>
            <AssistanceInfomation
              :task-info="taskInfo"
              :currentUser="currentUser"
              :isChange="isChange"
              :dateProcessing="dateProcessing"
              :result="result"
              :reasonFailure="reasonFailure"
              :countImageExplain="countImageExplain"
            />
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <VueLoadingOverlay :active.sync="isLoading" :is-full-page="true" />
    <!-- </Form> -->
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  import pad from 'lodash/pad'
  import { CallIoService } from '@/services/callio.service'
  // import { StaffService } from '@/services/staff.service'
  import { showMess } from '@/config/utils'
  import {
    WorkGroupList,
    WorkTaskList,
    WorkFormList,
    // TaskAdd,
    TaskDetail,
    // TaskUpdate,
    TaskUpdateStatus,
    // QuestionList,
    TaskProcess,
  } from '@/services/customer-support/task'
  // import {
  //   List as ListMo
  //   // GetList as GetMoByIds,
  // } from '@/services/customer-support/merchant-owner'
  // import { Search as ListMa } from '@/services/customer-support/account'
  // import { List as ListStore } from '@/services/customer-support/store'
  // import { SearchUser } from '@/services/customer-support/staff';
  // import { GetAssignment } from '@/services/customer-support/store-staff'
  // import SupportInfoProcess from './components/SupportInfoProcess.vue'
  import SupportInfo from './components/SupportInfo.vue'
  // import { nextTick } from 'vue'
  // import DateRangePicker from "vue2-daterange-picker";
  import InputRange from '@/components/InputRange.vue'
  // import _ from 'lodash'
  // import UploadMultiple from "@/components/UploadMultiple.vue";
  // import { Field, Form } from 'vee-validate';
  import {
    EnumTaskStatus,
    // EnumQuestionType,
    TaskStatus,
    TaskResultStatus,
    EnumTaskApplyFor,
    // TaskApplyFor,
    // FlowChangeStatus,
    EnumTaskMethodCare,
    TaskMethodCare,
    EnumTaskResultStatus,
    optionColorStatus,
    TRANSFORM_STATUS_OPTIONS,
  } from '@/constant/customerSupport'
  import UploadOneOrMultip from '@/components/cskh/UploadOneOrMultip.vue'
  import CollectInformation from './components/CollectInformation.vue'
  import { getDateAgo } from '@/utils/util'
  import AssistanceInfomation from './components/AssistanceInfomation.vue'
  import { CommonService } from '@/services/common.service'
  import ReasonFailure from './components/ReasonFailure.vue'
  import HotIcon from '@/assets/img/hot.gif'

  const currentUser = JSON.parse(localStorage.getItem('userData'))

  export default {
    name: 'CreateTask',
    components: {
      // SupportInfoProcess,
      // DateRangePicker,
      InputRange,
      // UploadMultiple,
      SupportInfo,
      UploadOneOrMultip,
      // Form,
      // Field,
      CollectInformation,
      AssistanceInfomation,
      ReasonFailure,
    },
    data() {
      return {
        currentUser,
        EnumTaskMethodCare,
        EnumTaskStatus,
        EnumTaskResultStatus,
        isLoading: true,
        // hasSubmit: false,
        id: '',
        taskInfo: {},
        callioConfig: JSON.parse(localStorage.getItem('callioConfig')) ?? {},
        taskCategoryOptions: [],
        taskNameOptions: [],
        methodCareOptions: TaskMethodCare,
        supportInfos: [],
        resultOptions: TaskResultStatus,
        isLoadingSupportInfos: false,
        afterSaleNote: '',
        dateProcessing: {
          startDate: null,
          endDate: null,
        },
        error: {
          afterSaleNote: '',
          dateProcessing: '',
          reasonFailure: '',
        },
        result: EnumTaskResultStatus.SUCCESS,
        reasonFailure: '',
        listReasonFailure: [],
        isChange: false,
        countImageExplain: 0,
        HotIcon,
        transformStatus: '',
        transformStatusOptions: TRANSFORM_STATUS_OPTIONS,
        historyCall: [],
        resultStatusCalls: [],
        historyCallFields: [
          { key: 'index', label: 'STT' },
          { key: 'toNumber', label: 'Liên hệ' },
          { key: 'username', label: 'Nhân sự' },
          { key: 'initCallIoTime', label: 'TG khởi tạo' },
          { key: 'createCallIoTime', label: 'TG thực hiện' },
          { key: 'timing', label: 'TG gọi' },
          { key: 'direction', label: 'Chiều gọi' },
          { key: 'crmResult', label: 'Kết quả' },
          { key: 'action', label: 'Thao tác', fixIndex: 999 },
        ],
      }
    },

    // watch: {
    //   dateProcessing: function (value) {
    //     return (
    //       this.hasSubmit &&
    //       this.newStatus === EnumTaskStatus.FINISH &&
    //       (!value.startDate || !value.endDate ? 'Hãy nhập thời gian xử lý' : '')
    //     )
    //   }
    // },

    created() {
      this.id = this.$router.currentRoute.params.id
    },

    async mounted() {
      this.loadAllData()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),

      canEdit() {
        return [EnumTaskStatus.NEW, EnumTaskStatus.PROCESSING].includes(this.taskInfo.status)
      },

      isUpdate() {
        return true
      },

      showDateAgo() {
        return date => {
          return getDateAgo(date)
        }
      },

      formatDate() {
        return date => {
          return moment(date).format('DD/MM/YYYY HH:mm')
        }
      },

      // showEstDate() {
      //   return (startDate, endDate) => {
      //     return startDate && endDate
      //       ? `${moment(startDate).format("DD/MM/YYYY HH:mm")} - ${moment(
      //         endDate
      //       ).format("DD/MM/YYYY HH:mm")}`
      //       : "";
      //   };
      // },

      getCategoryName() {
        const category = this.taskCategoryOptions.find(
          category => category.code === this.taskInfo.type
        )
        return category ? category.text : ''
      },

      getTaskName() {
        if (!this.taskInfo.purposes?.length) return ''
        const taskObject = this.taskNameOptions.find(
          task => task.code === this.taskInfo.purposes[0]
        )
        return taskObject ? taskObject.text : ''
      },
      getSubject() {
        const mapSubject = {
          MO: 'Merchant owner',
          MA: 'Merchant account',
          STORE: 'Cửa hàng',
        }

        return mapSubject[this.taskInfo?.applyFor] || ''
      },
      getMethodCareName() {
        const methodCareObj = this.methodCareOptions.find(s => s.id === this.taskInfo?.methodCare)
        return methodCareObj ? methodCareObj.text : ''
      },

      getStatusName() {
        const statusObj = TaskStatus.find(s => s.id === this.taskInfo?.status)
        return statusObj ? statusObj.text : ''
      },

      getStatusType() {
        return optionColorStatus[this.taskInfo?.status] || ''
      },

      hasCallioResult() {
        return (
          this.taskInfo?.callioResultText &&
          this.taskInfo.callioResultText !== null &&
          this.taskInfo.callioResultText !== ''
        )
      },

      // Task thuộc loại Ký HĐ Ngân Lượng - bỏ qua validate thông tin chăm sóc và thu thập thông tin
      isConvertNlTask() {
        return (
          Array.isArray(this.taskInfo?.purposes) &&
          this.taskInfo.purposes.includes('CHUYEN_DOI_NGAN_LUONG')
        )
      },
    },

    methods: {
      async loadAllData() {
        if (this.id) {
          await this.loadDataType()
          // await this.loadDataSupportInfo();
          await this.loadData()
          if (this.taskInfo.methodCare === EnumTaskMethodCare.ONLINE) {
            await this.loadDataSupportInfo()
          }
          await this.loadDataTask()
          // await this.loadQuestionList();
          // await this.checkUser();

          // Fetch call history and result status
          if (this.taskInfo.merchantInfo?.customerId) {
            await this.fetchHistory()
            await this.fetchResultStatusCall()
          }

          // set selected result
          this.taskInfo.result && (this.result = this.taskInfo.result)
          this.taskInfo.reasonFailure && (this.reasonFailure = this.taskInfo.reasonFailure)
          this.taskInfo.transformStatus && (this.transformStatus = this.taskInfo.transformStatus)

          // set oldvalue dateProcessing
          if (this.taskInfo?.startProcessing && this.taskInfo?.endProcessing) {
            this.dateProcessing.startDate = new Date(this.taskInfo.startProcessing)
            this.dateProcessing.endDate = new Date(this.taskInfo.endProcessing)
          }

          // Tự động điền thời gian nếu có kết quả callio và chưa có thời gian xử lý
          if (
            (!this.taskInfo?.startProcessing || !this.taskInfo?.endProcessing) &&
            this.taskInfo?.callioResultText !== null &&
            this.taskInfo?.callioResultText !== ''
          ) {
            // Chỉ lấy thời gian từ lịch sử cuộc gọi, không gán mặc định nếu không có lịch sử
            const timeFromHistory = this.calculateTimeFromCallHistory()
            if (timeFromHistory) {
              this.dateProcessing = timeFromHistory
              this.isChange = true
            }
          }

          // set selected support info
          if (this.taskInfo.methodCare !== EnumTaskMethodCare.OFFLINE) {
            const mapSupportInfo =
              this.taskInfo.formDataList?.reduce((map, item) => {
                for (const task of item.taskInFormDataList) {
                  map[`${task.formCode}|${task.taskInFormCode}`] = task
                }
                return map
              }, {}) || {}
            this.supportInfos.forEach(item => {
              item.taskInFormList.forEach(task => {
                task.isCheck = !!mapSupportInfo[`${task.formCode}|${task.taskInFormCode}`]
                task.images =
                  mapSupportInfo[`${task.formCode}|${task.taskInFormCode}`]?.images || []
              })
            })
            this.afterSaleNote = this.taskInfo.afterSaleNote
            this.$nextTick(() => {
              if (this.$refs.supportInfoRef) {
                this.$refs.supportInfoRef.setData(this.supportInfos)
                // this.$refs.supportInfoRef?.setValues(mapSupportInfo);
              }
              if (this.$refs.collectInformationRef) {
                this.$refs.collectInformationRef.setData(this.taskInfo?.collectionData || {})
              }
            })
          }

          // set selected image explanation
          this.uploadComponent = this.taskInfo?.explanationImage?.length || 0
          if (this.$refs.uploadComponent) {
            this.$refs.uploadComponent.setData(
              this.taskInfo?.explanationImage?.map(imgObj => {
                return {
                  url: imgObj.urlImage,
                  location: imgObj.location || 'website',
                  type: 'image',
                  uploaded: true,
                }
              }) || []
            )
          }
        } else {
          // show error
          showMess('error', 'Không tìm thấy dữ liệu')
        }

        await this.getConfigSystem()
      },

      handleChoiceChange(ques) {
        if (!ques.choice) {
          ques.optionResult = []
          ques.otherAnswerResult = ''
          delete ques.optionResult
          delete ques.otherAnswerResult
        }
      },
      handleOptionChange(val, ques) {
        if (val.length) {
          if (!val.includes('OTHER')) {
            ques.otherAnswerResult = ''
            delete ques.otherAnswerResult
          }
        } else {
          ques.otherAnswerResult = ''
          delete ques.otherAnswerResult
        }
      },
      handleQuizChange(val, ques) {
        if (val.length > 1) {
          ques.optionResult = val.slice(-1)
        }
      },
      async loadData() {
        try {
          this.isLoading = true
          const res = await TaskDetail(this.id)
          if (res.result) {
            this.taskInfo = res.data

            // nextTick(() => {
            //   // this.$refs.supportInfoProcessRef?.setData(res.data.formDataList || []);
            // })
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },

      async loadDataSupportInfo() {
        try {
          this.isLoadingSupportInfos = true
          const res = await WorkFormList({
            applyLevel: [EnumTaskApplyFor.MO, EnumTaskApplyFor.MA].includes(this.taskInfo.applyFor)
              ? 'MO_MA'
              : this.taskInfo?.applyFor,
            methodCare: this.taskInfo?.methodCare,
            taskCode: this.taskInfo?.purposes?.length ? this.taskInfo.purposes[0] : '',
            isActive: true,
          })
          if (res.result) {
            this.supportInfos = res.data?.listData || []
            // nextTick(() => {
            //   this.$refs.supportInfoRef?.setData(this.supportInfos)
            // })
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoadingSupportInfos = false
        }
      },

      required(value) {
        return value ? true : 'This field is required'
      },

      async loadDataType() {
        try {
          this.isLoading = true
          const res = await WorkGroupList({
            size: 100,
            page: 1,
          })
          if (res.result) {
            this.taskCategoryOptions = res.data.map(item => {
              return {
                id: item.id,
                text: item.groupName,
                code: item.groupCode,
              }
            })
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },

      async loadDataTask() {
        try {
          this.isLoading = true
          const category = this.taskCategoryOptions.find(
            category => category.code === this.taskInfo.type
          )
          if (category) {
            const res = await WorkTaskList({
              size: 100,
              page: 1,
              status: 'APPLYING',
              wkGroupId: category.id,
            })
            if (res.result) {
              this.taskNameOptions = res.data.map(item => {
                return {
                  id: item.id,
                  text: item.taskName,
                  code: item.taskCode,
                }
              })
            } else {
              showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
            }
          } else {
            showMess(
              this,
              'Error',
              'Không tìm thấy nhóm công việc',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },

      async getConfigSystem() {
        const config = await CommonService.getConfigSystem()
        if (config.success) {
          this.listReasonFailure = config.data.taskFailedReasons
        }
      },

      async submitForm(isShowConplete = true) {
        // this.hasSubmit = true

        // validate data
        if (this.result === EnumTaskResultStatus.FAILED && !this.reasonFailure) {
          this.error.reasonFailure = 'Vui lòng chọn lý do thất bại'
          showMess(
            this,
            'Error',
            'Hãy kiểm tra lại thông tin khác',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
          return false
        } else {
          this.error.reasonFailure = ''
        }
        // Chỉ validate thông tin chăm sóc nếu không có kết quả cuộc gọi và không phải task Ký HĐ Ngân Lượng
        if (
          !this.hasCallioResult &&
          !this.isConvertNlTask &&
          !this.$refs.supportInfoRef?.validate()
        ) {
          showMess(
            this,
            'Error',
            'Hãy kiểm tra lại thông tin chăm sóc',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
          return false
        }
        // Chỉ validate thông tin thu thập nếu không có kết quả cuộc gọi và không phải task Ký HĐ Ngân Lượng
        if (
          !this.hasCallioResult &&
          !this.isConvertNlTask &&
          !this.$refs.collectInformationRef?.validate()
        ) {
          showMess(
            this,
            'Error',
            'Hãy kiểm tra lại thông tin thu thập',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
          return false
        }

        // save data
        try {
          this.isLoading = true
          const explanationImage = await this.$refs.uploadComponent.saveData()
          await this.$refs.supportInfoRef?.saveData()
          const formDataList = this.$refs.supportInfoRef?.getData()
          const collectionData = this.$refs.collectInformationRef.getData()

          const res = await TaskProcess(this.id, {
            id: this.id,
            status: EnumTaskStatus.PROCESSING,
            formDataList,
            afterSaleNote: this.afterSaleNote,
            collectionData,
            explanationImage,
            result: this.result,
            startProcessing: this.dateProcessing.startDate
              ? new Date(this.dateProcessing.startDate).getTime()
              : undefined,
            endProcessing: this.dateProcessing.endDate
              ? new Date(this.dateProcessing.endDate).getTime()
              : undefined,
            reasonFailure: this.reasonFailure,
            transformStatus: this.transformStatus || undefined,
          })

          if (res.result) {
            if (isShowConplete) {
              this.showSuccessMx('Lưu thành công')
            }
            this.loadData()
            this.isChange = false
            return true
          } else {
            this.showFailMx(`Lưu thất bại: ${res.data?.message || res.message}`)
          }
          return false
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
          return false
        } finally {
          this.isLoading = false
        }
      },

      validateComplete() {
        if (this.dateProcessing.startDate) {
          const startDate = new Date(this.dateProcessing.startDate).getTime()
          const endDate = new Date(this.dateProcessing.endDate).getTime()
          const now = Date.now()
          if (startDate > endDate) {
            this.error.dateProcessing = 'Thời gian bắt đầu phải sau thời gian kết thúc'
            return false
          }

          if (endDate > now) {
            this.error.dateProcessing = 'Thời gian thực hiện công việc phải ở quá khứ'
            return false
          }
        } else {
          this.error.dateProcessing = 'Hãy chọn thời gian thực hiện'
          return false
        }
        this.error.dateProcessing = ''
        return true
      },

      async handleComplete() {
        if (this.isChange) {
          if (await this.submitForm(false)) {
            await this.updateStatusComplete()
          }
        } else {
          await this.updateStatusComplete()
        }
      },

      async updateStatusComplete() {
        // this.hasSubmit = true;

        // validate
        if (!this.isConvertNlTask && !this.validateComplete()) {
          showMess(
            this,
            'Error',
            'Hãy kiểm tra lại thời gian thực hiện công việc',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
          return false
        }

        // Chỉ bắt buộc ảnh giải trình nếu không có kết quả cuộc gọi và không phải task Ký HĐ Ngân Lượng
        if (!this.hasCallioResult && !this.isConvertNlTask && this.countImageExplain === 0) {
          showMess(
            this,
            'Error',
            'Hãy nhập ảnh giải trình',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
          return false
        }

        // save data
        try {
          this.isLoading = true
          const res = await TaskUpdateStatus(this.id, {
            id: this.id,
            status: EnumTaskStatus.FINISH,
            // result: "SUCCESS",
            startProcessing: this.dateProcessing.startDate
              ? new Date(this.dateProcessing.startDate).getTime()
              : undefined,
            endProcessing: this.dateProcessing.endDate
              ? new Date(this.dateProcessing.endDate).getTime()
              : undefined,
            transformStatus: this.transformStatus || undefined,
          })

          if (res.result) {
            this.showSuccessMx('Đã hoàn thành').then(() => {
              this.loadData()
            })
            return true
          } else {
            this.showFailMx(`Lưu thất bại: ${res.data?.message || res.message}`)
          }
          return false
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
          return false
        } finally {
          this.isLoading = false
        }
      },
      setOnchange(images) {
        this.isChange = true
        this.countImageExplain = images.length
      },
      calculateTimeFromCallHistory() {
        if (!this.historyCall || this.historyCall.length === 0) {
          return null
        }

        // Sắp xếp lịch sử cuộc gọi theo thời gian khởi tạo
        const sortedHistory = [...this.historyCall].sort((a, b) => {
          return new Date(a.initCallIoTime) - new Date(b.initCallIoTime)
        })

        const firstCall = sortedHistory[0]
        const lastCall = sortedHistory[sortedHistory.length - 1]

        // Thời gian bắt đầu: ưu tiên thời gian thực hiện (createCallIoTime) nếu có, nếu không dùng thời gian khởi tạo
        const startTime = new Date(firstCall.createCallIoTime || firstCall.initCallIoTime)

        // Thời gian kết thúc:
        // - Nếu có thời gian kết thúc cuộc gọi cuối cùng thì dùng thời gian đó
        // - Nếu không có thì dùng thời gian tạo cuộc gọi cuối cùng
        let endTime
        if (lastCall.endCallIoTime) {
          endTime = new Date(lastCall.endCallIoTime)
        } else if (lastCall.createCallIoTime) {
          endTime = new Date(lastCall.createCallIoTime)
        } else {
          // Fallback: dùng thời gian khởi tạo cuộc gọi cuối cùng
          endTime = new Date(lastCall.initCallIoTime)
        }

        // Đảm bảo thời gian kết thúc luôn ở quá khứ để tránh lỗi validation
        const now = new Date()
        if (endTime >= now) {
          // Trừ đi 1 giây để đảm bảo thời gian ở quá khứ
          endTime = new Date(now.getTime() - 1000)
        }

        return {
          startDate: startTime,
          endDate: endTime,
        }
      },

      handleCallioModalClose() {
        // Kiểm tra xem có kết quả cuộc gọi không trước khi gán thời gian
        if (
          this.taskInfo?.callioResultText &&
          this.taskInfo.callioResultText !== null &&
          this.taskInfo.callioResultText !== ''
        ) {
          // Chỉ tính toán thời gian từ lịch sử cuộc gọi, KHÔNG gán mặc định nếu không có lịch sử
          const timeFromHistory = this.calculateTimeFromCallHistory()
          if (timeFromHistory) {
            this.dateProcessing = timeFromHistory
            this.isChange = true
          }
        }
        // Load lại dữ liệu
        this.loadAllData()
      },
      processTaskWithCallio() {
        if (!this.taskInfo.merchantInfo) {
          this.showFailMx('Không tìm thấy thông tin merchant')
          return
        }
        if (this.taskInfo.applyFor === 'MA') {
          this.$store.commit('callio/SET_TMP_CURRENT_USER_CALL', {
            taskId: this.id,
            customerId: this.taskInfo.merchantInfo.customerId,
            customerName: this.taskInfo.merchantInfo.merchantName,
            mobile: this.taskInfo.merchantInfo.mobile,
            email: this.taskInfo.merchantInfo.email,
            city: this.taskInfo.merchantInfo.city,
            district: this.taskInfo.merchantInfo.district,
            task: this.taskInfo?.purposes[0] || '',
            taskGroup: this.taskInfo?.type || '',
            applyFor: this.taskInfo?.applyFor || '',
          })
        }
        if (this.taskInfo.applyFor === 'STORE') {
          this.$store.commit('callio/SET_TMP_CURRENT_USER_CALL', {
            taskId: this.id,
            customerId: this.taskInfo.merchantInfo.customerId,
            customerName: this.taskInfo.merchantInfo.merchantName,
            mobile: this.taskInfo.storeInfo.mobile,
            email: this.taskInfo.storeInfo.email,
            city: this.taskInfo.storeInfo?.city,
            district: this.taskInfo.storeInfo?.district,
            task: this.taskInfo?.purposes[0] || '',
            taskGroup: this.taskInfo?.type || '',
            applyFor: this.taskInfo?.applyFor || '',
            storeId: this.taskInfo.storeInfo?.storeId,
          })
        }

        this.$store.commit('callio/SET_MODAL', true)
        this.$store.commit('callio/SET_MODAL_MINI', false)
        this.$store.commit('callio/SET_MODAL_CLOSE_CALLBACK', this.handleCallioModalClose)
      },
      getTiming(endCallIoTime, createCallIoTime) {
        if (!endCallIoTime) return ''
        const end = moment(endCallIoTime)
        const start = moment(createCallIoTime)
        const duration = moment.duration(end.diff(start))
        return `${pad(duration.hours(), 2, '0')}:${pad(duration.minutes(), 2, '0')}:${pad(
          duration.seconds(),
          2,
          '0'
        )}`
      },
      async listenRecord(id) {
        this.isLoading = true
        try {
          const res = await CallIoService.getRecording(id)
          window.open(res.data.url, '_blank')
        } catch (error) {
          console.log(error)
        } finally {
          this.isLoading = false
        }
      },
      detailCall(id) {
        const routeData = this.$router.resolve({ path: `/call-io/${id}` })
        window.open(routeData.href, '_blank')
      },
      async fetchResultStatusCall() {
        try {
          const params = {
            taskId: this.id,
            task: this.taskInfo?.purposes[0] || '',
            taskGroup: this.taskInfo?.type || '',
          }
          const response = await CallIoService.getResultStatusCall(params)
          this.resultStatusCalls = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async fetchHistory() {
        try {
          const params = {
            page: 1,
            size: 20,
            customerId: this.taskInfo.merchantInfo.customerId,
            taskId: this.id,
          }
          const response = await CallIoService.getHistoryCallIo(params)
          this.historyCall = response.data.list
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .card-section {
    width: 100%;
    -webkit-box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);
    box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);
    border-radius: 10px;

    .header-section {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      position: relative;
      margin-left: 10px;

      &::before {
        content: ' ';
        position: absolute;
        width: 4px;
        height: 24px;
        background: #13569f;
        left: -10px;
      }
    }

    .form-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;

      &:first-child {
        margin-top: 0;
      }

      .form-label {
        font-weight: 400;
        font-size: 14px;
        color: #2a2a2a;
        //max-width: 150px;

        &.require::after {
          content: '*';
          color: #f00;
          margin-left: 4px;
        }
      }

      .form-input {
        width: 60%;

        .error {
          color: #f00;
        }
      }
    }
  }

  .no-data {
    width: 100%;
    color: #999;
    border: 1px solid #ddd;
    height: 60px;
    align-items: center;
    border-radius: 5px;
    display: flex;
    justify-content: center;
  }

  .question-code {
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 500;
    color: black;
  }

  ::v-deep(.custom-control-label) {
    line-height: 24px;
  }

  .form-quescard {
    margin-bottom: 5px !important;
  }

  .collapse {
    &.show {
      .question-card {
        border-bottom: 1px solid #ddd;
      }
    }
  }

  .question-border {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 5px;
    width: 100%;

    &.collapsed {
      border-bottom: 1px solid #ddd;
    }

    &:hover {
      background-color: #eee;
    }
  }

  .not-collapsed {
    .question-code {
      padding: 10px;
    }

    &::after {
      content: '▲';
      font-size: 16px;
      color: #999;
      margin-left: 5px;
    }
  }

  .collapsed {
    .question-code {
      padding: 10px;
    }

    &::after {
      content: '▼';
      font-size: 16px;
      color: #999;
      margin-left: 5px;
    }
  }

  .opacity-50 {
    opacity: 0.5;
  }
</style>
